import { render } from "./IconItem.vue?vue&type=template&id=99dbc87e&scoped=true"
import script from "./IconItem.vue?vue&type=script&lang=js"
export * from "./IconItem.vue?vue&type=script&lang=js"

import "./IconItem.vue?vue&type=style&index=0&id=99dbc87e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-99dbc87e"

export default script